<template>
  <v-content>
    <v-layout wrap row justify-center class="mt-5">
      <v-flex xs12 sm6>
        <ContactForm_Support_offline></ContactForm_Support_offline>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import Vue from 'vue'
import ContactForm_Support_offline from './widgets/ContactForm_Support_offline'

export default {
  name: 'PasswordContact',
  components: {ContactForm_Support_offline},
  methods: {
    open: function () {
    }
  },
  data () {
    return {}
  },
  mounted () {
    Vue.prototype.$eventHub.$emit('OnShowLogin', true)
    Vue.prototype.$eventHub.$emit('OnShowRegister', true)
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/PasswordContact.vue